export var machineProcessedState = {
  type: 'final'
};